import { atom } from "recoil";

export const isHomeAISearchVisibleState = atom<boolean>({
    key: "isHomeAISearchVisibleState",
    default: true,
});
